import { render, staticRenderFns } from "./AttributeEditOrAdd.vue?vue&type=template&id=275bc522&scoped=true"
import script from "./AttributeEditOrAdd.vue?vue&type=script&lang=ts"
export * from "./AttributeEditOrAdd.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275bc522",
  null
  
)

export default component.exports